import { render } from "./KriInfoModal.vue?vue&type=template&id=2ed3eacd&scoped=true"
import script from "./KriInfoModal.js?vue&type=script&lang=js"
export * from "./KriInfoModal.js?vue&type=script&lang=js"

import "./KriInfoModal.vue?vue&type=style&index=0&id=2ed3eacd&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed3eacd"]])

export default __exports__